module.exports = __webpack_public_path__ + "img/download.265c7362.svg";